import type { ReactNode } from 'react';

import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@connected/ui/components/tooltip';
import { cn } from '@connected/ui/lib/utils';

export type ObservationProps<T extends ReactNode = ReactNode> = {
    label: string;
    color: string;
    isPreview?: boolean;
    className?: string;
    children: T;
    small?: boolean;
};

export function Observation({
    label,
    color,
    isPreview,
    className,
    children,
    small = false,
}: ObservationProps) {
    if (isPreview) {
        return <div className={cn('text-primary font-semibold py-1', className)}>{children}</div>;
    }

    if (!color) {
        return null;
    }

    return (
        <div className={cn('', className)}>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger>
                        <div
                            className={cn(
                                !small ? 'flex items-center justify-center h-9 w-9 lg:h-7 lg:w-7 xl:h-8 xl:w-8 rounded-full' : 'flex items-center rounded-full justify-center h-6 w-6',
                                color === '#FFFFFF' || color === '#ffffff' ? 'border border-gray-300' : '',
                            )}
                            style={{
                                backgroundColor: color,
                                color:
                                            color === '#e9eaeb'
                                                ? '#929292'
                                                : color === '#def3f6'
                                                    ? '#63949b'
                                                    : '#ffffff',
                            }}
                        >
                            <span className="font-light">{children}</span>
                        </div>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>{label}</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
